var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography } from '@mui/material';
import { Component } from 'react';
import { colors } from '../styles/MuiTheme';
import { downloadFile, localState } from '../utils/file';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasError: _this.props.error ? true : false,
            error: _this.props.error,
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { hasError: true, error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        var _a;
        if (this.state.hasError) {
            return (_jsxs("div", { children: [this.props.beforeErrorComponent, _jsxs("div", __assign({ style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        } }, { children: [_jsxs(Typography, __assign({ color: "error", variant: "body1", sx: { textAlign: 'center', mt: 5 } }, { children: ["Something went wrong. Please try refreshing the page.", _jsx("br", {}), "If the problem persists, reach out on discord, with this error message:", _jsx("br", {}), _jsx("br", {})] })), _jsx("pre", __assign({ style: {
                                    fontSize: '16px',
                                    backgroundColor: 'black',
                                    color: 'white',
                                    padding: '10px',
                                    borderRadius: '5px',
                                } }, { children: (_a = this.state.error) === null || _a === void 0 ? void 0 : _a.message })), _jsx(Typography, __assign({ sx: {
                                    color: colors.rsLightestBrown,
                                    textAlign: 'center',
                                }, variant: "body2" }, { children: "If you're going to report this error on the discord please include the app state, you can download it below." })), _jsx(Box, __assign({ sx: { display: 'flex', justifyContent: 'center' } }, { children: _jsx(Button, __assign({ sx: { width: '250px', mt: 5 }, variant: "outlined", onClick: function () {
                                        var state = localState();
                                        var fileName = "filterscape_state_".concat(Date.now()
                                            .toString()
                                            .replaceAll('/', '-'), ".json");
                                        var file = new File([JSON.stringify(state)], fileName, {
                                            type: 'text/plain',
                                        });
                                        downloadFile(file);
                                    } }, { children: "Download Local State" })) }))] }))] }));
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(Component));
export { ErrorBoundary };
